export default __webpack_public_path__ + "static/mob-img-3916108349b8155585354ea92dca03a8.png";